import history from '../../utils/createHistory';
/**
 * Gets the pagename from the url and stores it as in redux
 * If url update on click item feature is implemented then, add the parameter search below path name
 *  and keys like ?view=pagename
 * @returns {*}
 */

export function updateURLQueryString(
  params,
  overridingOptions = {},
  pushOrReplace = 'push',
) {
  const qs = params;
  history[pushOrReplace]({
    pathname: qs,
    ...overridingOptions,
  });
}
